export default __webpack_public_path__ + "static/ekko-34d826fdac53149a6789745b4c8e2e7c.png";